const PROTECTED_KEYS = ["password", "newPassword"];

// Fields masked only under a given parent, where the same name is harmless
// elsewhere: the preference centre `url` is a magic link carrying the customer's
// token, while other `url` fields (brand pages, guides) are public.
const PROTECTED_NESTED_KEYS: Array<{ parent: string; key: string }> = [
  { parent: "consentPreferenceCenter", key: "url" },
];

export const maskSensitiveData = (
  data: Record<string, unknown> | undefined,
): Record<string, unknown> | undefined =>
  maskNode(data, { parentKey: undefined });

function maskNode(
  data: object | undefined,
  { parentKey }: { parentKey: string | undefined },
): Record<string, unknown> | undefined {
  if (!data) {
    return data;
  }

  return Object.entries(data).reduce(
    (acc, [key, value]) => {
      if (
        value &&
        typeof value === "string" &&
        isProtected(key, { parentKey })
      ) {
        acc[key] = "[PROTECTED DATA]";
      } else if (typeof value === "object" && value !== null) {
        acc[key] = maskNode(value, { parentKey: key });
      } else {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, unknown>,
  );
}

function isProtected(
  key: string,
  { parentKey }: { parentKey: string | undefined },
): boolean {
  return (
    PROTECTED_KEYS.includes(key) ||
    PROTECTED_NESTED_KEYS.some(
      (nested) => nested.key === key && nested.parent === parentKey,
    )
  );
}
